import { render, staticRenderFns } from "./ImpressumIcon.vue?vue&type=template&id=019a5f03"
import script from "./ImpressumIcon.vue?vue&type=script&lang=js"
export * from "./ImpressumIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports